<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 155px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>
    <!--TOPIC DAN PEROIDE BERITA-->
    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDate1 === '' && showDate2 === '') || (showDate1 !== '' && showDate2 !== '' && selectedPeriode !== 'Custom'),
        'd-flex ma-0 pa-0 ml-1': showDate1 !== '' && showDate2 !== '' && selectedPeriode === 'Custom'
      }"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          label="Topic"
          dense
          outlined
          rounded
          @change="isChangeTopic = true, statusFilter = '', selectedSource = '', selectedSourceId = '', parameter_proses_topic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topickeywordsentiment"
          v-model="selectedKeyword"
          class="elevation-0 shadow-0"
          label="Keyword"
          dense
          outlined
          rounded
          @click="isChangeKeyword = true"
          @change="isChangeKeyword = true, parameter_proses_keyword()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          label="Periode Berita"
          dense
          outlined
          rounded
          @change="parameter_proses_periode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small dark width="120" color="#0471A5">
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="ma-4" justify="space-around">
                      <v-date-picker
                        v-model="date1"
                        dense
                        :show-current="false"
                        color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="date2"
                        class="ml-8"
                        :show-current="false"
                        color="#0471A5"
                        header-color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="menu = false, parameter_proses_custom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDate1[1] + " " + showDate1[0] + " " + showDate1[2] }} - {{ showDate2[1] + " " + showDate2[0] + " " + showDate2[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Button Hit API -->
      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDate1 === '' && showDate2 === '') || (showDate1 !== '' && showDate2 !== '' && selectedPeriode !== 'Custom'),
          'd-flex ma-0 pa-0': showDate1 !== '' && showDate2 !== '' && selectedPeriode === 'Custom'
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="#439EDF"
          height="40"
          style="max-width: 100%;"
          dense
          dark
          rounded
          block
          @click="parameter_proses_periode(), loadChartPie()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
      <!-- End Button Hit API -->

      <v-col
        v-if="(showDate1 == '' && showDate2 == '' || showDate1 != '' && showDate2 != '') && selectedPeriode != 'Custom'"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <!-- Filter logika -->
        <v-btn
          class="mr-3"
          color="#439EDF"
          height="40"
          style="max-width: 100%;"
          dense
          dark
          rounded
          outlined
          block
          @click="dialogFilterLogika = true"
        >
          <v-icon>mdi-plus</v-icon>
          Filter
        </v-btn>
      </v-col>

      <v-col
        v-if="(showDate1 == '' && showDate2 == '' || showDate1 != '' && showDate2 != '') && selectedPeriode != 'Custom'"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <!-- Reset -->
        <v-btn
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>

      <v-col
        v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <!-- Filter logika -->
        <v-btn
          class="mr-3"
          color="#439EDF"
          height="40"
          style="max-width: 100%;"
          dense
          dark
          rounded
          outlined
          block
          @click="dialogFilterLogika = true"
        >
          <v-icon>mdi-plus</v-icon>
          Filter
        </v-btn>
      </v-col>

      <v-col
        v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'"
        class="d-flex ma-0 pa-0"
        cols="12"
        sm="1"
      >
        <!-- Reset -->
        <v-btn
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg4>
        <v-card class="mb-6 rounded-lg" color="#F4F7FA" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 mb-6 rounded-lg pa-4" height="350px" flat :style="navbarWithName ? 'width: 400px;' : ''">
                <div>
                  <v-card-title>Sentiment Analysis</v-card-title>
                  <apexchart
                    :options="chartPie"
                    :series="seriesdonut"
                    type="donut"
                    width="350px"
                    @dataPointSelection="filterBySentiment"
                  ></apexchart>
                </div>
              </v-card>
            </v-flex>

            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 rounded-lg pa-4" height="455px" flat :style="navbarWithName ? 'width: 400px;' : ''">
                <v-card-title>Content List</v-card-title>
                <v-tabs color="#0471A5">
                  <v-tab @click="contentListSentiment('Positive')">
                    Positive
                    <v-chip small class="ma-2" color="#0471A5" text-color="white">
                      {{ beritaPositivePersen }} % / {{ beritaPositive }} Data
                    </v-chip>
                  </v-tab>
                  <v-tab class="ml-8" @click="contentListSentiment('Netral')">
                    Netral
                    <v-chip small class="ma-2" color="#0471A5" text-color="white">
                      {{ beritaNetralPersen }} % / {{ beritaNetral }} Data
                    </v-chip>
                  </v-tab>
                  <v-tab class="ml-8" @click="contentListSentiment('Negative')">
                    Negative
                    <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                      {{ beritaNegativePersen }} % / {{ beritaNegative }} Data
                    </v-chip>
                  </v-tab>

                  <v-tab-item style="background-color: #f5f5f5">
                    <v-card class="elevation-0 overflow-card" height="327px">
                      <v-row class="ma-2">
                        <v-flex v-for="(item, index) in kontenBeritaPositive" :key="item.id" lg12>
                          <v-card
                            :href="item.url"
                            target="_blank"
                            flat
                            :class="{'rounded-lg custom-card': index == 0, 'mt-2 rounded-lg custom-card': index != 0}"
                            style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                          >
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.title }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.content }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                      <div class="d-flex align-center">
                                        <v-avatar v-if="item.source == 'berita'" class="color-avatar4" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-web
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Twitter'" class="color-avatar6" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-x-twitter
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'youtube'" class="color-avatar2" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-youtube
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'tik tok'" class="color-avatar6" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-tiktok
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'instagram'" class="color-avatar7" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-instagram
                                          </v-icon>
                                        </v-avatar>
                                        <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                          {{ item.url }}
                                        </span>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item style="background-color: #f5f5f5">
                    <v-card class="elevation-0 overflow-card" height="327px">
                      <v-row class="ma-2">
                        <v-flex v-for="(item, index) in kontenBeritaNetral" :key="item.id" lg12>
                          <v-card
                            :href="item.url"
                            target="_blank"
                            flat
                            :class="{'rounded-lg custom-card': index == 0, 'mt-2 rounded-lg custom-card': index != 0}"
                            style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                          >
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.title }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.content }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                      <div class="d-flex align-center">
                                        <v-avatar v-if="item.source == 'berita'" class="color-avatar4" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-web
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Twitter'" class="color-avatar6" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-x-twitter
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'youtube'" class="color-avatar2" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-youtube
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'tik tok'" class="color-avatar6" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-tiktok
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'instagram'" class="color-avatar7" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-instagram
                                          </v-icon>
                                        </v-avatar>
                                        <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                          {{ item.url }}
                                        </span>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item style="background-color: #f5f5f5">
                    <v-card class="elevation-0 overflow-card" height="327px">
                      <v-row class="ma-2">
                        <v-flex v-for="(item, index) in kontenBeritaNegative" :key="item.id" lg12>
                          <v-card
                            :href="item.url"
                            target="_blank"
                            flat
                            :class="{'rounded-lg custom-card': index == 0, 'mt-2 rounded-lg custom-card': index != 0}"
                            style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                          >
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.title }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.content }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                      <div class="d-flex align-center">
                                        <v-avatar v-if="item.source == 'berita'" class="color-avatar4" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-web
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Twitter'" class="color-avatar6" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-x-twitter
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'youtube'" class="color-avatar2" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-youtube
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'tik tok'" class="color-avatar6" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-tiktok
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'instagram'" class="color-avatar7" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-instagram
                                          </v-icon>
                                        </v-avatar>
                                        <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                          {{ item.url }}
                                        </span>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card>
              <div v-if="tabsSentiment == 'Positive'" class="text-center">
                <v-pagination
                  class="mt-2 my-2"
                  v-model="pagePositive"
                  :length="pageLengthPositive"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="handlePageChangePositive"
                ></v-pagination>
              </div>
              <div v-if="tabsSentiment == 'Netral'" class="text-center">
                <v-pagination
                  class="mt-2 my-2"
                  v-model="pageNetral"
                  :length="pageLengthNetral"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="handlePageChangeNetral"
                ></v-pagination>
              </div>
              <div v-if="tabsSentiment == 'Negative'" class="text-center">
                <v-pagination
                  class="mt-2 my-2"
                  v-model="pageNegative"
                  :length="pageLengthNegative"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="handlePageChangeNegative"
                ></v-pagination>
              </div>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg8 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'ml-6 mb-6 rounded-lg' : 'mb-6 rounded-lg'" color="#F4F7FA" flat>
          <v-row class="ma-2">
            <v-flex lg12>
              <v-card class="rounded-lg pa-4" height="240px" flat>
                <v-card-title>Statistics</v-card-title>
                <v-row class="pa-0 mt-0">
                  <v-flex lg4>
                    <v-card class="mx-4 rounded-lg" height="auto" flat>
                      <v-list-item three-line>
                        <v-avatar class="color-avatar" size="48">
                          <span class="white--text text-h5">
                            <v-icon color="#fff">mdi-chart-donut</v-icon>
                          </span>
                        </v-avatar>
                        <v-list-item-content class="ml-4">
                          <v-list-item-subtitle class="accent-2">
                            <h3>Total Collected Data</h3>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="primary--text text-h6">
                            {{ selectedTopicTotalCollectedData }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <h2 color="deep-purple accent-2">
                              {{ totalCollectedData }}
                            </h2>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-flex>

                  <v-flex lg4 sm12 md12 xs12>
                    <v-card class="mx-4 rounded-lg" height="auto" flat>
                      <v-list-item three-line>
                        <v-avatar class="color-avatarmostcrawledkeyword" size="48">
                          <span class="white--text text-h5">
                            <v-icon color="#fff">mdi-format-font</v-icon>
                          </span>
                        </v-avatar>
                        <v-list-item-content class="ml-4">
                          <v-list-item-subtitle>
                            <h3>Most Crawled Keyword</h3>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="primary--text text-h6">
                            {{ valueMostTotalKeyword.name }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <h2 color="deep-purple">
                              {{ valueMostTotalKeyword.count }}
                            </h2>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-flex>

                  <v-flex lg4 sm12 md12 xs12>
                    <v-card class="mx-4 rounded-lg" height="auto" flat>
                      <v-list-item three-line>
                        <v-avatar class="btn-ok" size="48">
                          <span class="white--text text-h5">
                            <v-icon color="#fff">mdi-clock-time-three-outline</v-icon>
                          </span>
                        </v-avatar>
                        <v-list-item-content class="ml-4">
                          <v-list-item-subtitle class="accent-2">
                            <h3>Least Crawled Keyword</h3>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="primary--text text-h6">
                            {{ valueLeastTotalKeyword.name }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <h2 color="deep-purple accent-2">
                              {{ valueLeastTotalKeyword.count }}
                            </h2>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-flex>

            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mt-6 rounded-lg pa-4" height="auto" flat>
                <v-card-title>Periodic Crawled Data</v-card-title>
                <apexcharts
                  :options="sentimentanalysis"
                  :series="seriessentiment"
                  class="mt-4 py-4"
                  type="area"
                  width="100%"
                  height="360px"
                ></apexcharts>
                <v-row :class="{ 'mt-1 justify-center mb-4': listSourceCollection.length == 2 || listSourceCollection.length == 1 }">
                  <v-flex
                    v-for="item in listSourceCollection"
                    :key="item.ID"
                    xs12
                    sm12
                    md12
                    lg2
                    :style="{
                      marginTop: '15px',
                      marginRight: listSourceCollection.length == 2
                        ? (navbarWithName ? '56px' : '66px')
                        : listSourceCollection.length == 3
                        ? (navbarWithName ? '56px' : '126px')
                        : listSourceCollection.length == 4
                        ? (navbarWithName ? '56px' : '66px')
                        : listSourceCollection.length == 5
                        ? (navbarWithName ? '56px' : '26px')
                        : '56px'
                    }"
                  >
                    <v-btn
                      :class="{
                        'ml-1 mt-3 mb-10': listSourceCollection.length == 5,
                        'ml-3 mt-3 mb-10': listSourceCollection.length == 4,
                        'ml-13 mt-3 mb-10': listSourceCollection.length == 3
                      }"
                      :style="{
                        backgroundColor: selectedSourceId == item.ID ? '#e1f2fa' : '#fff',
                        width: listSourceCollection.length == 4
                          ? '185px'
                          : listSourceCollection.length == 5
                          ? '155px'
                          : '185px'
                      }"
                      style="color: #0471A5; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                      color="#fff"
                      height="80"
                      x-large
                      @click="
                        if (selectedSourceId == item.ID) {
                          selectedSourceId = '';
                          selectedSource = '';
                          changeBackgroundColor = !changeBackgroundColor;
                        } else {
                          selectedSourceId = item.ID;
                          selectedSource = item.NAME_COLLECTION;
                          changeBackgroundColor = true;
                        }
                        loadChartArea();
                      "
                    >
                      <v-card-text>
                        <h2 class="text--teal darken-2" align="center">
                          <v-avatar v-if="item.ICON == 'mdi-web'" class="color-avatar4" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'fa-brands fa-x-twitter'" class="color-avatar6" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'mdi-youtube'" class="color-avatar2" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'fa-brands fa-tiktok'" class="color-avatar6" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'mdi-instagram'" class="color-avatar7" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <span v-if="item.ICON == 'mdi-web'">
                            {{ valueTotalBerita }} ({{ totalCollectedData ? Math.round((valueTotalBerita / totalCollectedData) * 100) : 0 }}%)
                          </span>
                          <span v-if="item.ICON == 'fa-brands fa-x-twitter'">
                            {{ valueTotalTwet }} ({{ totalCollectedData ? Math.round((valueTotalTwet / totalCollectedData) * 100) : 0 }}%)
                          </span>
                          <span v-if="item.ICON == 'mdi-youtube'">
                            {{ valueTotalYt }} ({{ totalCollectedData ? Math.round((valueTotalYt / totalCollectedData) * 100) : 0 }}%)
                          </span>
                          <span v-if="item.ICON == 'fa-brands fa-tiktok'">
                            {{ valueTotalTikTok }} ({{ totalCollectedData ? Math.round((valueTotalTikTok / totalCollectedData) * 100) : 0 }}%)
                          </span>
                          <span v-if="item.ICON == 'mdi-instagram'">
                            {{ valueTotalIG }} ({{ totalCollectedData ? Math.round((valueTotalIG / totalCollectedData) * 100) : 0 }}%)
                          </span>
                        </h2>
                        <h5 v-if="item.ICON == 'mdi-web'" class="text--teal darken-2" align="center">
                          Total Berita Online
                        </h5>
                        <h5 v-if="item.ICON == 'fa-brands fa-x-twitter'" class="text--teal darken-2" align="center">
                          Total Tweet
                        </h5>
                        <h5 v-if="item.ICON == 'mdi-youtube'" class="text--teal darken-2" align="center">
                          Total Comment Youtube
                        </h5>
                        <h5 v-if="item.ICON == 'fa-brands fa-tiktok'" class="text--teal darken-2" align="center">
                          Total TikTok
                        </h5>
                        <h5 v-if="item.ICON == 'mdi-instagram'" class="text--teal darken-2" align="center">
                          Total Instagram
                        </h5>
                      </v-card-text>
                    </v-btn>
                  </v-flex>
                </v-row>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout style="margin-left: 2px; margin-right: -4px;" row wrap>
      <v-flex lg6>
        <v-card class="card-container mr-3 mb-6 rounded-lg pa-4" height="400" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 mb-6 rounded-lg pa-4" height="350px" flat :style="navbarWithName ? 'width: 400px;' : ''">
                <div>
                  <v-card-title>Online News Portals</v-card-title>
                  <apexchart
                    :options="barchart"
                    :series="seriesBarOnlineNews"
                    type="bar"
                    height="300"
                  ></apexchart>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg6>
        <v-card class="card-container ml-3 mb-6 rounded-lg pa-4" height="400" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 mb-6 rounded-lg pa-4" height="350px" flat :style="navbarWithName ? 'width: 400px;' : ''">
                <div>
                  <v-card-title>Social Media Channels</v-card-title>
                  <apexchart
                    :options="barchartSocialMedia"
                    :series="seriesBarSocialMedia"
                    type="bar"
                    height="300"
                  ></apexchart>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="#0471A5"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialog = false, openDialogInfo()">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFilterLogika" max-width="500px">
        <v-card style="overflow-x: hidden">
          <v-toolbar height="50px" color="#439EDF" dark>
            Filter logika
          </v-toolbar>
          <v-card-text class="pa-6 overflow-card" style="height: 400px; background-color:#F4F7FA;">
            <v-card class="mb-4" style="background-color:#F4F7FA;" flat>
              <v-row class="ma-0 pa-0 my-3">
                <v-flex lg4>
                  <v-select
                    :items="itemsFilterLogika"
                    item-text="logic"
                    item-value="logic"
                    v-model="valueFilterLogika"
                    label="Logic Filter"
                    dense
                    outlined
                    @change="disableLogicFilter"
                  ></v-select>
                </v-flex>
                <v-flex lg4 class="mx-3">
                  <v-text-field
                    v-model="valueKataKunci"
                    label="Kata Kunci"
                    dense
                    outlined
                    v-on:input="updateKataKunci"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="listObjFilterLogika.length == 0" lg3>
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-btn icon @click="addFilterLogika()">
                      <v-icon color="primary">
                        mdi-plus-circle
                      </v-icon>
                    </v-btn>
                  </v-card-text>
                </v-flex>
              </v-row>
              <v-row v-for="(item, i) in listObjFilterLogika" :key="i" class="ma-0 pa-0 my-3">
                <v-flex lg4>
                  <v-select
                    :items="itemsSelectFilterLogika[i]"
                    item-text="logic"
                    item-value="logic"
                    v-model="listObjFilterLogika[i].operator"
                    dense
                    outlined
                    @change="changeSelectFilterLogika(listObjFilterLogika[i].operator, i)"
                  ></v-select>
                </v-flex>
                <v-flex lg4 class="mx-3">
                  <v-text-field
                    v-model="listObjFilterLogika[i].keyword_logic"
                    dense
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="i == listObjFilterLogika.length - 1" lg3>
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-btn icon @click="addFilterLogikaInList(item, i)">
                      <v-icon color="primary">
                        mdi-plus-circle
                      </v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteFilterLogika(i)">
                      <v-icon color="red">
                        mdi-minus-circle
                      </v-icon>
                    </v-btn>
                  </v-card-text>
                </v-flex>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogFilterLogika = false, finalObjFilterLogika()">
              Cancel
            </v-btn>
            <v-btn text color="#439EDF" @click="dialogFilterLogika = false, finalObjFilterLogika()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogInfo" height="500" width="350">
        <v-card class="pa-5" rounded="lg" color="#439EDF" dark>
          <v-btn class="ml-auto" style="position: absolute; top: 5px; right: 5px; color: white;" icon @click="dialogInfo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text class="text-center" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;">
            <h3 class="white--text mb-4">
              Keyword Search Results
            </h3>
            <p class="white--text">
              Topic: <strong>{{ selectedTopicTotalCollectedData }}</strong>
              <br>
              From: <strong>{{ startDateInfo }}</strong> to <strong>{{ endDateInfo }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn
            class="ma-0 pa-0"
            style="position: absolute; top: 10px; right: 10px;"
            color="#aaa"
            small
            icon
            @click="dialogConfirmReset = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar color="#eee" style="border: 2px solid #ddd;" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                isClickSentiment = false,
                statusFilter = '',
                selectedSource = '',
                selectedSourceId = '',
                changeBackgroundColor = false,
                loadTopic(),
                parameter_proses_periode(),
                filterReset()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
// import io from 'socket.io-client';
import VueApexCharts from 'vue-apexcharts';
import Notification from '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
// let ipSocket = process.env.VUE_APP_API;

export default {
  components: {
    apexcharts: VueApexCharts,
    Notification: Notification
  },
  data: function() {
    return {
      dialogConfirmReset: false,
      dialogInfo: false,
      startDateInfo: "",
      endDateInfo: "",
      // socket: io(ipSocket),
      menu: false,
      dialog: false,
      changeBackgroundColor: false,
      listSourceCollection: "",
      selectedSourceId: "",
      selectedSource: "",
      isChangeTopic: false,
      isChangeKeyword: false,
      selectedTopic: "",
      selectedTopicTotalCollectedData: "",
      totalCollectedData: "",
      valueMostTotalKeyword: "",
      valueLeastTotalKeyword: "",
      selectedKeyword: "",
      selectedPeriode: "Last 7 Days",
      topicsentiment: [],
      topickeywordsentiment: [],
      periodeberita: [
        "Today",
        "Yesterday",
        "Last 7 Days",
        "Previous Week",
        "Last 30 Days",
        "Previous Month",
      ],
      showDate1: "",
      showDate2: "",
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      listSentiment: ["Positive", "Netral", "Negative"],
      tabsSentiment: "Positive",
      pageplay: 100,
      pagePositive: "",
      pageNetral: "",
      pageNegative: "",
      pageLengthPositive: "",
      pageLengthNetral: "",
      pageLengthNegative: "",
      valueKataKunci: "",
      finalObjectFilterLogika: [],
      objFilterLogika: [],
      listObjFilterLogika: [],
      listFilterLogika: [],
      listFilterLogikaLogic: [],
      valueFilterLogika: "Logic Filter",
      itemsFilterLogika: [
        {
          logic: "Logic Filter",
          disabled: false,
        },
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        },
      ],
      itemsSelectFilterLogika: [],
      selectedLogika: "Or",
      dialogFilterLogika: false,
      isClickSentiment: false,
      statusFilter: "",
      nerPersonSearch: "",
      nerOrganizationSearch: "",
      chartNews: [],
      chartTweet: [],
      chartYt: [],
      chartInstagram: [],
      chartTikTok: [],
      chartCombinasi: [],
      mediaBerita: [],
      MediatwitterShare: [],
      MediaYtShare: [],
      kontenBeritaAll: [],
      kontenBerita: [],
      kontenTweet: [],
      kontenYoutube: [],
      kontenBeritaPositive: [],
      kontenBeritaNetral: [],
      kontenBeritaNegative: [],
      beritaPositivePersen: "",
      beritaNetralPersen: "",
      beritaNegativePersen: "",
      valueTotalBerita: "",
      valueTotalTwet: "",
      valueTotalYt: "",
      valueTotalIG: "",
      valueTotalTikTok: "",
      chartPieMedol: [],
      chartPieSocialMedol: [],
      alert: false,
      colorAlert: "",
      message: "",
      Settanggal: [],
      sentimentanalysis: {
        chart: {
          id: 'Memory Usage',
          background: 'transparent'
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
          x: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#45AF5B', '#FF1752', '#008FFB'],
        xaxis: {
          categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriessentiment: [],

      seriesdonut: [],
      chartPie: {
        colors: ['#008FFB', '#FF4560', '#00E396'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        labels: ['Netral', 'Negative', 'Positive'],
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
        },
      },

      /*bar chart*/
      seriesBarOnlineNews: [{
        data: []
      }],
      barchart: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            },
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 120
          },
          tickAmount: 'dataPoints'
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="custom-tooltip">' +
              '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
              '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>';
          }
        }
      },
      seriesBarSocialMedia: [{
        data: []
      }],
      barchartSocialMedia: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            }
          }
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="custom-tooltip">' +
              '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
              '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>';
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
  mounted() {
    this.loadTopic();
    // this.getRealTimeData();
  },
  methods: {
    openDialogInfo() {
      this.dialogInfo = true;
      setTimeout(() => {
        this.dialogInfo = false;
      }, 10000);
    },
    getRealTimeData() {
      this.socket.on("listUpdate", fetchedData => {
        // Remove non-printable and other non-valid JSON characters
        var s = fetchedData.replace(/\\n/g, "\\n")
                  .replace(/\\'/g, "\\'")
                  .replace(/\\"/g, '\\"')
                  .replace(/\\&/g, "\\&")
                  .replace(/\\r/g, "\\r")
                  .replace(/\\t/g, "\\t")
                  .replace(/\\b/g, "\\b")
                  .replace(/\\f/g, "\\f");
        var dataUpdate = JSON.parse(s);
        console.log(dataUpdate);
        this.kontenBeritaAll = [];
        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        this.kontenBeritaAll = dataUpdate;
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Netral") {
            this.kontenBeritaNetral.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(dataUpdate[i]);
          }
        }
        this.loadKontenBerita();
        this.updateSocket = true;
      })
    },
    // update show custom date
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    finalObjFilterLogika() {
      let objFilterLogikaIndex0 = [];
      if (this.valueFilterLogika == "Logic Filter") {
        this.objFilterLogika[0].operator = "";
      }
      objFilterLogikaIndex0.push(this.objFilterLogika[0]);
      this.finalObjectFilterLogika = objFilterLogikaIndex0.concat(this.listObjFilterLogika);
      this.$store.commit("addButtonTmp", {
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
      });
    },
    updateKataKunci() {
      this.objFilterLogika[0].keyword_logic = this.valueKataKunci;
    },
    disableLogicFilter() {
      for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
        this.itemsSelectFilterLogika[i][0].disabled = false;
        this.itemsSelectFilterLogika[i][1].disabled = false;
        this.itemsSelectFilterLogika[i][2].disabled = false;
      }
      this.itemsFilterLogika[0].disabled = true;
      for (let i = 0; i < this.listObjFilterLogika.length; i++) {
        this.listObjFilterLogika[i].operator = this.valueFilterLogika;
      }
      if (this.valueFilterLogika == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (this.valueFilterLogika == "Not") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][0].disabled = true;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      this.objFilterLogika[0].operator = this.valueFilterLogika;
    },
    changeSelectFilterLogika(logic, index) {
      for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
        this.itemsSelectFilterLogika[i][0].disabled = false;
        this.itemsSelectFilterLogika[i][1].disabled = false;
        this.itemsSelectFilterLogika[i][2].disabled = false;
      }
      if (this.listObjFilterLogika[0].operator == "And") {
        let operatorAnd = [];
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          operatorAnd.push(this.listObjFilterLogika[i].operator);
        }
        if (operatorAnd.includes("Or")) {
          let indexOr = operatorAnd.indexOf("Or");
          for (let i = indexOr + 1; i < this.itemsSelectFilterLogika.length; i++) {
            this.itemsSelectFilterLogika[i][1].disabled = true;
            this.itemsSelectFilterLogika[0][1].disabled = false;
          }
        }
      }
      if (logic == "Or" && this.listObjFilterLogika[0].operator == "Or") {
        for (let i = 0 + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "Not" && this.listObjFilterLogika[0].operator == "Or") {
        for (let i = 0 + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
          this.itemsSelectFilterLogika[0][1].disabled = false;
        }
      }
      if (logic == "Not" && this.valueFilterLogika == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "Or" && this.valueFilterLogika == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "And") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
        }
      }
      if (logic == "Or") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "Not") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
          this.itemsSelectFilterLogika[i][0].disabled = true;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
    },
    addFilterLogika() {
      let objFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: this.valueKataKunci
      };
      let listObjFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: ""
      };
      let listSelectFilterLogika = [
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        }
      ];
      this.objFilterLogika.push(objFilterLogika);
      this.listObjFilterLogika.push(listObjFilterLogika);
      this.itemsSelectFilterLogika.push(listSelectFilterLogika);
      this.listFilterLogika.push(this.valueKataKunci);
      this.listFilterLogikaLogic.push(this.selectedLogika);
    },
    addFilterLogikaInList(logic, index) {
      if (logic.operator == "Not" && this.listObjFilterLogika[0].operator == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
          this.itemsSelectFilterLogika[0][1].disabled = false;
        }
      }
      if (this.listObjFilterLogika[0].operator == "Or" || this.listObjFilterLogika[0].operator == "And") {
        this.selectedLogika = "Or";
      }
      if (this.listObjFilterLogika[0].operator == "Not") {
        this.selectedLogika = "Not";
      }
      let objFilterLogika = {
        operator: logic.operator,
        keyword_logic: logic.keyword_logic
      };
      let listObjFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: ""
      };
      let listSelectFilterLogika = [
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        }
      ];
      this.objFilterLogika.push(objFilterLogika);
      this.listObjFilterLogika.push(listObjFilterLogika);
      this.itemsSelectFilterLogika.push(listSelectFilterLogika);
      this.listFilterLogika.push(this.valueKataKunci);
      this.listFilterLogikaLogic.push(this.selectedLogika);
      if (logic.operator == "Or") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic.operator == "Not") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = "Not";
          this.itemsSelectFilterLogika[i][0].disabled = true;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
    },
    deleteFilterLogika(i) {
      let listFilterLogika = this.listFilterLogika;
      listFilterLogika.splice(i, 1);
      this.objFilterLogika.splice(i, 1);
      this.listObjFilterLogika.splice(i, 1);
      this.itemsSelectFilterLogika.splice(i, 1);
      let listFilterLogikaAfterDelete = this.listFilterLogika;
      this.listFilterLogika = listFilterLogikaAfterDelete;
    },

    async loadTopic() {
      this.dialog = true;
      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        const data_dec = decryptionData(response.data.token);
        this.posts = data_dec.keyword;
        const data = data_dec.keyword;
        // alert(data.length);
        for (let i = 0; i < data.length; i++) {
          // sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicsentiment.length; i++) {
            if (this.selectedTopic == this.topicsentiment[i].TOPIC) {
              this.selectedTopic = this.topicsentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          // send parameter store
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          // sincron data topic sentiment
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  // this.selectedKeyword = (data[i].KEYWORD[x].KEYWORD);
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              // alert(data[i].KEYWORD[x].KEYWORD);
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
            this.selectedTopicTotalCollectedData = data[i].TOPIC;
          }
        }

        // topickeywordsentiment
        var date_start = this.date1;
        var date_end = this.date2;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          const date_awal = new Date();
          const date = new Date();
          date.setDate(date.getDate() + 0);
          const datenow = date.toISOString().substr(0, 10);
          if (this.selectedPeriode == "Today") {
            date_start = datenow;
            date_end = datenow;
          }
          if (this.selectedPeriode == "Yesterday") {
            date_awal.setDate(date_awal.getDate() - 1);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = date_c;
          }
          if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
            date_awal.setDate(date_awal.getDate() - 7);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = datenow;
          }
          if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
            date_awal.setDate(date_awal.getDate() - 30);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = datenow;
          }
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          // alert('aaa');
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
            date_start_glob: date_start,
            date_end_glob: date_end,
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.date1 = this.$store.date_start_glob;
          this.date2 = this.$store.date_end_glob;
        }

        this.listSourceCollection = data_dec.collection;
        this.startDateInfo = date_start;
        this.endDateInfo = date_end;

        // console.log(this.$store.date_start_glob)
        if (data.length > 0) {
          this.loadChartPie();
        }
        if (this.selectedPeriode == "Custom") {
          this.showCustomDate();
        }
      })
      .catch((e) => {
        this.dialog = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error"); // end up here all the time
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select refused to connect";
          this.colorAlert = "red";
        }
      });
    },

    async parameter_proses_topic() {
      var date_start = this.date1;
      var date_end = this.date2;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        // sincron data topic sentiment
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              // this.selectedKeyword = (this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            // alert(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD +' - '+ x);
            this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      if (this.selectedKeyword != "All") {
        this.selectedKeyword = "All";
      }
    },
    async parameter_proses_keyword() {
      var date_start = this.date1;
      var date_end = this.date2;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      this.parameter_proses_periode();
    },
    async parameter_proses_periode() {
      var date_start = this.date1;
      var date_end = this.date2;
      const date_awal = new Date();
      const date = new Date();
      date.setDate(date.getDate() + 0);
      const datenow = date.toISOString().substr(0, 10);
      if (this.selectedPeriode == "Today") {
        date_start = datenow;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Yesterday") {
        date_awal.setDate(date_awal.getDate() - 1);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = date_c;
      }
      if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
        date_awal.setDate(date_awal.getDate() - 7);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
        date_awal.setDate(date_awal.getDate() - 30);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      this.startDateInfo = date_start;
      this.endDateInfo = date_end;
    },

    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";

      // alert(this.selectedPeriode);
      var date_start = this.date1;
      var date_end = this.date2;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
    },

    filterBySentiment(event, chartContext, config) {
      this.isClickSentiment = true;
      this.statusFilter = config.dataPointIndex;
      if (this.statusFilter == 0) {
        this.statusFilter = "Netral";
      }
      if (this.statusFilter == 1) {
        this.statusFilter = "Negative";
      }
      if (this.statusFilter == 2) {
        this.statusFilter = "Positive";
      }
      this.$store.commit("addButtonTmp", {
        // sentiment_glob: this.statusFilter,
        // ner_person_glob: this.$store.ner_person_glob,
        // ner_organization_glob: this.$store.ner_organization_glob,
      });
      this.loadChartPie();
    },

    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
      this.loadChartPie();
    },

    async loadChartPie() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        const data_chart_pie = await axios.post(
          `tranding-topic-chart-pie?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        if (this.isClickSentiment == false) {
          this.seriesdonut[0] = data_chart_pie.data.data.count_netral;
          this.seriesdonut[1] = data_chart_pie.data.data.count_negative;
          this.seriesdonut[2] = data_chart_pie.data.data.count_positive;
        }
        if (this.isClickSentiment == true) {
          if (this.statusFilter == "Netral") {
            this.seriesdonut[0] = data_chart_pie.data.data.count_netral;
            this.seriesdonut[1] = 0;
            this.seriesdonut[2] = 0;
          }
          if (this.statusFilter == "Negative") {
            this.seriesdonut[0] = 0;
            this.seriesdonut[1] = data_chart_pie.data.data.count_negative;
            this.seriesdonut[2] = 0;
          }
          if (this.statusFilter == "Positive") {
            this.seriesdonut[0] = 0;
            this.seriesdonut[1] = 0;
            this.seriesdonut[2] = data_chart_pie.data.data.count_positive;
          }
        }

        if (this.isClickSentiment == false) {
          this.valueTotalBerita = data_chart_pie.data.data.count_news;
          this.valueTotalTwet = data_chart_pie.data.data.count_twitter;
          this.valueTotalYt = data_chart_pie.data.data.count_youtube;
          this.valueTotalTikTok = data_chart_pie.data.data.count_tiktok;
          this.valueTotalIG = data_chart_pie.data.data.count_instagram;
        }

        for (let i = 0; i < this.topicsentiment.length; i++) {
          if (this.topicsentiment[i].SEQ_ID == this.$store.topic_glob) {
            this.selectedTopicTotalCollectedData = this.topicsentiment[i].TOPIC;
          }
        }

        if (this.isChangeKeyword == false) {
          this.totalCollectedData = this.valueTotalBerita + this.valueTotalTwet + this.valueTotalYt + this.valueTotalTikTok + this.valueTotalIG;
        }

        if (this.isClickSentiment == false) {
          var count_all = data_chart_pie.data.data.count_positive + data_chart_pie.data.data.count_netral + data_chart_pie.data.data.count_negative;
          const beritaPositivePersen = data_chart_pie.data.data.count_positive / count_all * 100;
          this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
          this.beritaPositive = data_chart_pie.data.data.count_positive;

          const beritaNetralPersen = data_chart_pie.data.data.count_netral / count_all * 100;
          this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
          this.beritaNetral = data_chart_pie.data.data.count_netral;

          const beritaNegativePersen = data_chart_pie.data.data.count_negative / count_all * 100;
          this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
          this.beritaNegative = data_chart_pie.data.data.count_negative;
          if (isNaN(beritaPositivePersen)) {
            this.beritaPositivePersen = 0;
          }
          if (isNaN(beritaNetralPersen)) {
            this.beritaNetralPersen = 0;
          }
          if (isNaN(beritaNegativePersen)) {
            this.beritaNegativePersen = 0;
          }
        }
        if (this.isClickSentiment == true) {
          if (this.statusFilter == "Positive") {
            this.beritaPositivePersen = 100;
            this.beritaNetralPersen = 0;
            this.beritaNetral = 0;
            this.beritaNegativePersen = 0;
            this.beritaNegative = 0;
          }
          if (this.statusFilter == "Netral") {
            this.beritaNetralPersen = 100;
            this.beritaPositivePersen = 0;
            this.beritaPositive = 0;
            this.beritaNegativePersen = 0;
            this.beritaNegative = 0;
          }
          if (this.statusFilter == "Negative") {
            this.beritaNegativePersen = 100;
            this.beritaPositivePersen = 0;
            this.beritaPositive = 0;
            this.beritaNetralPersen = 0;
            this.beritaNetral = 0;
          }
        }

        this.pagePositive = 1;
        this.pageNetral = 1;
        this.pageNegative = 1;
        this.pageLengthPositive = Math.ceil(data_chart_pie.data.data.count_positive / this.pageplay);
        this.pageLengthNetral = Math.ceil(data_chart_pie.data.data.count_netral / this.pageplay);
        this.pageLengthNegative = Math.ceil(data_chart_pie.data.data.count_negative / this.pageplay);

        window.dispatchEvent(new Event("resize"));
        this.mostLeastCrawler();
      } catch(e) {
        console.log(e);
        this.dialog = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Trending Topic Chart Pie Response Data Not Found";
        this.colorAlert = "red";
      }
    },
    async mostLeastCrawler() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        const response = await axios.post(
          `most-least-crawler?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(response.data.token);
        const cleanKeyword = (keyword) => keyword.replace(/content:|clean_text:|title:/g, "");

        const mergeCrawlerData = (crawlerArray, combinedData) => {
          if (Array.isArray(crawlerArray) && crawlerArray.length) {
            crawlerArray.forEach((item) => {
              if (item.most) {
                Object.entries(item.most).forEach(([name, count]) => {
                  const cleanName = cleanKeyword(name);
                  combinedData[cleanName] = (combinedData[cleanName] || 0) + count;
                });
              }
            });
          }
        };

        const combinedData = {};

        mergeCrawlerData(data.most_crawler, combinedData);
        mergeCrawlerData(data.most_crawlerTwitter, combinedData);
        mergeCrawlerData(data.most_crawlerYoutube, combinedData);
        mergeCrawlerData(data.most_crawlerInstagram, combinedData);
        mergeCrawlerData(data.most_crawlerTikTok, combinedData);

        const combinedArray = Object.entries(combinedData).map(([name, count]) => ({ name, count }));

        const mostFrequent = combinedArray.length ? combinedArray.reduce((prev, current) => (prev.count > current.count ? prev : current)) : { name: "-", count: 0 };
        const leastFrequent = combinedArray.length ? combinedArray.reduce((prev, current) => (prev.count < current.count ? prev : current)) : { name: "-", count: 0 };

        if (!this.isChangeKeyword || this.isChangeTopic) {
          this.valueMostTotalKeyword = mostFrequent;
          this.valueLeastTotalKeyword = leastFrequent;
        }

        window.dispatchEvent(new Event("resize"));
        this.loadChartArea();
        this.isChangeKeyword = false;
      } catch (e) {
        console.error(e);
        this.dialog = false;
        this.alert = true;
        this.message = "API Most Least Crawler Response Data Not Found";
        this.colorAlert = "red";
        setTimeout(() => {
          this.alert = false;
        }, 10000);
      }
    },

    async loadChartArea() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        const data_chart_pie = await axios.post(
          `tranding-topic-chart-area?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        this.processData(data_chart_pie.data.data);
      } catch(e) {
        console.log(e);
        this.dialog = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Trending Topic Chart Area Response Data Not Found";
        this.colorAlert = "red";
      }
    },

    processData(data) {
      const combinedData = {};
      const platforms = ["date_news", "date_twitter", "date_instagram", "date_tiktok", "date_youtube"];
      const platformNames = ["News", "Twitter", "Instagram", "Tik Tok", "Youtube"];

      this.seriessentiment = [];
      const categories = [];

      const aggregateData = (platformData, platformName, seriesIndex) => {
        platformData.forEach((item) => {
          const date = item.date;
          if (!combinedData[date]) {
            combinedData[date] = { date: new Date(date).getTime(), counts: [] };
          }
          if (!combinedData[date].counts[seriesIndex]) {
            combinedData[date].counts[seriesIndex] = 0;
          }
          combinedData[date].counts[seriesIndex] += item.Total;
        });
      };

      const platformColors = {
        News: '#6F6F6F',
        Twitter: '#FFB000',
        Instagram: '#814AD6',
        'Tik Tok': '#000',
        Youtube: '#FF0000',
      };

      let selectedColors = [];

      if (this.selectedSource == "") {
        platforms.forEach((platformKey, index) => {
          const platformData = data[platformKey] || [];
          aggregateData(platformData, platformNames[index], index);

          const isPlatformExists = this.listSourceCollection.some(
            (item) => item.NAME_SOCIAL_MEDIA == platformNames[index]
          );

          if (isPlatformExists) {
            this.seriessentiment.push({
              name: platformNames[index],
              data: [],
            });

            if (platformColors[platformNames[index]]) {
              selectedColors.push(platformColors[platformNames[index]]);
            }
          }
        });

        const categoriesSet = new Set(Object.keys(combinedData));
        const sortedCategories = Array.from(categoriesSet).sort();

        sortedCategories.forEach((category) => {
          categories.push(new Date(category).getTime());
          platforms.forEach((platformKey, index) => {
            const formattedDate = this.formatDate(category);
            const count = combinedData[category]?.counts[index] || 0;

            const sentimentIndex = this.seriessentiment.findIndex(
              (s) => s.name == platformNames[index]
            );

            if (sentimentIndex != -1) {
              this.seriessentiment[sentimentIndex].data.push({
                x: formattedDate,
                y: count,
              });
            }
          });
        });

        this.sentimentanalysis.xaxis.categories = categories;
      }
      if (this.selectedSource != "") {
        const selectedPlatformKey = `date_${this.selectedSource.toLowerCase()}`;
        const selectedPlatformData = data[selectedPlatformKey] || [];

        this.seriessentiment = [
          { name: "Positive", data: [] },
          { name: "Netral", data: [] },
          { name: "Negative", data: [] },
        ];

        selectedPlatformData.forEach((item) => {
          const date = item.date;
          const formattedDate = this.formatDate(date);

          this.seriessentiment[0].data.push({ x: formattedDate, y: item.Positive });
          this.seriessentiment[1].data.push({ x: formattedDate, y: item.Netral });
          this.seriessentiment[2].data.push({ x: formattedDate, y: item.Negative });
        });

        selectedColors = ['#00E396', '#008FFB', '#FF4560'];
      }

      this.sentimentanalysis = {
        ...this.sentimentanalysis,
        colors: selectedColors,
      };

      if (this.isClickSentiment == true) {
        if (this.seriessentiment[0] && this.seriessentiment[0].data) {
          this.valueTotalBerita = this.seriessentiment[0].data.reduce((sum, item) => sum + item.y, 0);
        }
        if (this.seriessentiment[1] && this.seriessentiment[1].data) {
          this.valueTotalTwet = this.seriessentiment[1].data.reduce((sum, item) => sum + item.y, 0);
        }
        if (this.seriessentiment[2] && this.seriessentiment[2].data) {
          this.valueTotalYt = this.seriessentiment[2].data.reduce((sum, item) => sum + item.y, 0);
        }
        if (this.seriessentiment[3] && this.seriessentiment[3].data) {
          this.valueTotalIG = this.seriessentiment[3].data.reduce((sum, item) => sum + item.y, 0);
        }
        if (this.seriessentiment[4] && this.seriessentiment[4].data) {
          this.valueTotalTikTok = this.seriessentiment[4].data.reduce((sum, item) => sum + item.y, 0);
        }
        this.totalCollectedData = this.valueTotalBerita + this.valueTotalTwet + this.valueTotalYt + this.valueTotalTikTok + this.valueTotalIG;
      }

      this.loadContent();
    },

    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },

    async loadContent() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        let defaultSentimentContent = "Positive";
        if (this.statusFilter != "") {
          defaultSentimentContent = this.statusFilter;
        }
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        const data_content = await axios.post(
          `tranding-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${defaultSentimentContent}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(data_content.data.token);
        this.kontenBeritaAll = [];

        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        const content = data.data;

        content.forEach(item => {
          if (item.sentiment == 'Positive') {
            this.kontenBeritaPositive.push(item);
          }
          if (item.sentiment == 'Netral') {
            this.kontenBeritaNetral.push(item);
          }
          if (item.sentiment == 'Negative') {
            this.kontenBeritaNegative.push(item);
          }
        });

        window.dispatchEvent(new Event("resize"));
        this.newsMediaChannel();
      } catch(e) {
        console.log(e);
        this.dialog = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Trending Topic Content Response Data Not Found";
        this.colorAlert = "red";
      }
    },

    async newsMediaChannel() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        const data_chart_pie = await axios.post(
          `news-media-channel?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(data_chart_pie.data.token);

        this.seriesBarOnlineNews[0].data = [];
        this.barchart = {
          colors: ['#38BABC', '#16A5A7', '#079092'],
          chart: {
            height: 300,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              columnWidth: '45%',
              distributed: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                fontSize: '12px'
              },
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
              trim: false,
              maxHeight: 120
            },
            tickAmount: 'dataPoints'
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return '<div class="custom-tooltip">' +
                '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
                '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
                '</div>';
            }
          }
        };

        let resultonlinenews = [];
        if (data.news_portal.length != 0) {
          resultonlinenews = data.news_portal[0].data;
        }
        if (resultonlinenews.length > 0) {
          resultonlinenews.forEach((val, key) => {
            if (key < 10) {
              this.seriesBarOnlineNews[0].data[key] = "";
              this.barchart.xaxis.categories[key] = "";
              this.seriesBarOnlineNews[0].data[key] = val.count;
              this.barchart.xaxis.categories[key] = val.name;
            }
          });
        }

        this.seriesBarSocialMedia = [{ data: [] }];
        this.barchartSocialMedia = {
          colors: ['#38BABC', '#16A5A7', '#079092'],
          chart: {
            height: 300,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              columnWidth: '45%',
              distributed: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return '<div class="custom-tooltip">' +
                '<span>' + (w.config.xaxis.categories[dataPointIndex] || '') + '</span>' +
                '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
                '</div>';
            }
          }
        };

        if (this.valueTotalTwet != 0 || this.valueTotalYt != 0 || this.valueTotalIG != 0 || this.valueTotalTikTok != 0) {
          const filteredListSourceCollection = this.listSourceCollection.filter(item => item.NAME_SOCIAL_MEDIA != "News");
          const pairedData = filteredListSourceCollection.map(item => {
            if (item.NAME_SOCIAL_MEDIA == "Twitter") {
              return { name: "Twitter", value: this.valueTotalTwet };
            }
            if (item.NAME_SOCIAL_MEDIA == "Youtube") {
              return { name: "YouTube", value: this.valueTotalYt };
            }
            if (item.NAME_SOCIAL_MEDIA == "Instagram") {
              return { name: "Instagram", value: this.valueTotalIG };
            }
            if (item.NAME_SOCIAL_MEDIA == "Tik Tok") {
              return { name: "Tik Tok", value: this.valueTotalTikTok };
            }
          })

          pairedData.sort((a, b) => b.value - a.value);

          this.seriesBarSocialMedia[0].data = [];

          pairedData.forEach((item, key) => {
            this.barchartSocialMedia.xaxis.categories[key] = item.name;
            this.seriesBarSocialMedia[0].data.push(item.value);
          });
        }

        window.dispatchEvent(new Event("resize"));
        this.dialog = false;
      } catch(e) {
        console.log(e);
        this.dialog = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API News Media Channel Response Data Not Found";
        this.colorAlert = "red";
      }
      this.openDialogInfo();
    },

    async contentListSentiment(sentiment) {
      if (this.isClickSentiment == false) {
        this.tabsSentiment = sentiment;
        this.dialog = true;
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        try {
          const data_content = await axios.post(
            `tranding-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${sentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
            {},
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const data = decryptionData(data_content.data.token);
          this.kontenBeritaAll = [];
          this.kontenBeritaPositive = [];
          this.kontenBeritaNetral = [];
          this.kontenBeritaNegative = [];
          const content = data.data;

          content.forEach(item => {
            if (sentiment == 'Positive') {
              this.kontenBeritaPositive.push(item);
            }
            if (sentiment == 'Netral') {
              this.kontenBeritaNetral.push(item);
            }
            if (sentiment == 'Negative') {
              this.kontenBeritaNegative.push(item);
            }
          });
          this.dialog = false;
        } catch(e) {
          console.log(e);
          this.dialog = false;
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "Data Not Found";
          this.colorAlert = "red";
        }
      }
    },

    async handlePageChangePositive(value) {
      this.dialog = true;

      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };

      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const startPage = this.pageplay * (value - 1);

      if (this.selectedSource == "berita") {
        this.selectedSource = "mediaonline";
      }
      if (this.selectedSource == "twitter") {
        this.selectedSource = "twitter2";
      }
      if (this.selectedSource == "tik tok") {
        this.selectedSource = "tiktok";
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const data1 = await axios.post(
          `tranding-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.tabsSentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=${startPage}&rows=${this.pageplay}&sourceCollection=${this.selectedSource}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        const data = decryptionData(data1.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = data.data;
        this.kontenBeritaPositive = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(data.data[i]);
          }
        }

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    },
    async handlePageChangeNetral(value) {
      this.dialog = true;

      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };

      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const startPage = this.pageplay * (value - 1);

      if (this.selectedSource == "berita") {
        this.selectedSource = "mediaonline";
      }
      if (this.selectedSource == "twitter") {
        this.selectedSource = "twitter2";
      }
      if (this.selectedSource == "tik tok") {
        this.selectedSource = "tiktok";
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const data1 = await axios.post(
          `tranding-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.tabsSentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=${startPage}&rows=${this.pageplay}&sourceCollection=${this.selectedSource}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        const data = decryptionData(data1.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = data.data;
        this.kontenBeritaNetral = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Netral") {
            this.kontenBeritaNetral.push(data.data[i]);
          }
        }

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    },
    async handlePageChangeNegative(value) {
      this.dialog = true;

      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };

      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const startPage = this.pageplay * (value - 1);

      if (this.selectedSource == "berita") {
        this.selectedSource = "mediaonline";
      }
      if (this.selectedSource == "twitter") {
        this.selectedSource = "twitter2";
      }
      if (this.selectedSource == "tik tok") {
        this.selectedSource = "tiktok";
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const data1 = await axios.post(
          `tranding-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.tabsSentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=${startPage}&rows=${this.pageplay}&sourceCollection=${this.selectedSource}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        const data = decryptionData(data1.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = data.data;
        this.kontenBeritaNegative = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(data.data[i]);
          }
        }

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    },
  }
}
</script>

<style> /*note css jangan diubah*/
.v-pagination {
  z-index: 10 !important;
  position: relative;
}
.card-container {
  margin: 0 auto;
  padding: 1rem;
}
.custom-card {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
}

.custom-card:hover {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
  box-shadow: 3px 5px 7px 0px #E4E4E4 !important;
}
.custom-tooltip {
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
}
.custom-tooltip span {
  display: block;
  margin-bottom: 3px;
  font-size: 12px;
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}
.btn-ok {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatarmostcrawledkeyword {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000) !important;
}
.v-avatar.color-avatar6 {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}
.v-avatar.color-avatar7 {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}
.v-avatar.color-avatar3 {
  background-image:
  linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
</style>
